export default __webpack_public_path__ + "static/media/curseofthelotus.de9c950a.png";